<script lang="ts">
	import { beforeUpdate } from 'svelte';
	// Stores
	import { firmwares_gen_2 } from 'src/stores/device-runtime/process';
	import { getDeviceStatus, getDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	import { getDeviceState } from 'src/stores/device-runtime/states';
	// Services and configs
	import { devices_config } from 'src/configs/devices';

	// Helpers
	import {
		get_gen_2_component_channel_structure,
		get_gen_2_control_component_channel_structure,
		is_gen_2,
		real_id,
	} from 'src/helpers/interface_helpers';
	import { status_configurator } from 'src/helpers/device_data_helpers';
	import { roller_is_calibrated } from 'src/helpers/requests/calibrate_cover';

	// Design System Components
	// Components
	import ControlPositionG2 from 'src/components/Controls/Single/ControlPositionG2.svelte';
	import ControlDirectionDevicePageG2V2 from 'src/components/Controls/Single/ControlDirectionDevicePageG2V2.svelte';
	import TimerRemaining from 'src/components/TimerRemaining/TimerRemaining.svelte';
	import DeviceNotificationLabel from 'src/components/Sidepanel/DeviceNotificationLabel.svelte';
	import DeviceViewStateWrapper from 'src/components/Sidepanel/DeviceViews/DeviceViewStateWrapper.svelte';
	import DeviceLabelList from 'src/components/Sidepanel/DeviceViews/DeviceLabelList.svelte';

	// Types
	import type { Device } from 'src/types/Device.ts';

	export let device: Device;

	const deviceConfig = devices_config?.[device?.type];
	const isGen2 = is_gen_2(device);

	$: statusStore = getDeviceStatus(device?.id);
	$: status = $statusStore;
	$: settingsStore = getDeviceSettings(device?.id);
	$: settings = $settingsStore;

	// Status and label processing
	$: _statusesRaw =
		status?.online && deviceConfig ? status_configurator(status, device, settings) : null;
	$: _statuses = (Array.isArray(_statusesRaw) ? _statusesRaw : []) as any[];
	$: labelList = _statuses.filter((e) => {
		return 'undefined' === typeof e.main && e.name !== 'state';
	});
	$: combinedLabelList = [...Object.values(timerLabels), ...labelList];

	let timerLabels: Record<string, any> = {};
	let timer = false;
	let deviceState: any = getDeviceState(device?.id);

	// Roller mode specific calculations
	$: rollerCalibrated = roller_is_calibrated(device, status, settings);
	$: rollerLostPosition =
		status?.[`${get_gen_2_component_channel_structure(device)}`]?.current_pos === null;
	$: positioningControl = true;

	beforeUpdate(() => {
		if (status?.online && deviceConfig) {
			timer =
				isGen2 &&
				typeof status?.[`${get_gen_2_component_channel_structure(device)}`]?.timer_started_at !==
					'undefined';
		}
		deviceState = getDeviceState(device?.id);
	});
</script>

<DeviceViewStateWrapper {device}>
	<div
		slot="staticTop"
		class="label-list-wrapper mb-s d-flex flex-direction-column justify-content-center"
	>
		{#if timer}
			{#key status[get_gen_2_control_component_channel_structure(device)].timer_started_at}
				<TimerRemaining timerKey="gen2_main" {device} {status} {settings} bind:timerLabels />
			{/key}
		{/if}
		<DeviceLabelList labelList={combinedLabelList} />
		<DeviceNotificationLabel deviceId={device?.id} />
	</div>

	<div class="flex-full-height justify-content-end" slot="staticBottom" style="margin-top: auto;">
		{#if rollerCalibrated && !rollerLostPosition && positioningControl}
			<ControlPositionG2 {device} {status} {settings} />
		{/if}
		<ControlDirectionDevicePageG2V2 {device} {status} />
	</div>
</DeviceViewStateWrapper>
